// Languages Vale's interface supports.
// Keep in step with SUPPORTED_LANGUAGES in backend/routers/settings.py.
//   code       — i18next / stored on the user
//   nativeName — shown in the picker, in that language
//   dir        — text direction for <html dir>
//   speech     — default BCP-47 tag for speech recognition and spoken replies
export const LANGUAGES = [
  { code: "en", name: "English", nativeName: "English", dir: "ltr", speech: "en-US" },
  { code: "zh", name: "Chinese (Simplified)", nativeName: "中文（简体）", dir: "ltr", speech: "zh-CN" },
  { code: "hi", name: "Hindi", nativeName: "हिन्दी", dir: "ltr", speech: "hi-IN" },
  { code: "es", name: "Spanish", nativeName: "Español", dir: "ltr", speech: "es-ES" },
  { code: "ar", name: "Arabic", nativeName: "العربية", dir: "rtl", speech: "ar-SA" },
  { code: "fr", name: "French", nativeName: "Français", dir: "ltr", speech: "fr-FR" },
  { code: "vi", name: "Vietnamese", nativeName: "Tiếng Việt", dir: "ltr", speech: "vi-VN" },
];

export const DEFAULT_LANGUAGE = "en";
export const LANGUAGE_CODES = LANGUAGES.map((l) => l.code);

const baseOf = (code) => String(code || "").toLowerCase().split(/[-_]/)[0];

/** "es-MX" → "es"; anything unsupported → English. */
export const normaliseLanguage = (code) => {
  const base = baseOf(code);
  return LANGUAGE_CODES.includes(base) ? base : DEFAULT_LANGUAGE;
};

export const languageInfo = (code) =>
  LANGUAGES.find((l) => l.code === normaliseLanguage(code));

/**
 * Speech tag for a UI language. If the browser's own locale is a regional
 * variant of the same language (e.g. en-AU), use it so recognition matches
 * the person's accent; otherwise use the language's default.
 */
export const speechLangFor = (code) => {
  const info = languageInfo(code);
  const nav = typeof navigator !== "undefined" ? navigator.language || "" : "";
  return nav.includes("-") && baseOf(nav) === info.code ? nav : info.speech;
};
